import { put, call } from 'redux-saga/effects';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { toast } from 'react-toastify';
import { EMPLOYEE_DATA_ACTIONS } from '../actions/EmployeeDataActions';
import { employeeDataCreateAPI, employeeDataSearchAPI, employeeDataUpdateAPI } from 'src/api/EmployeeDataApi';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data,
        } = yield call(employeeDataSearchAPI, {
            where,
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data:{
                data,
            },
        } = yield call(employeeDataSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(employeeDataCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("EmployeeData Created")
        
        yield put({
            type: EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_UPSERT_ERROR,
        });
    }
}

function* update(employeeDataId, payload) {
    try {
        yield call(employeeDataUpdateAPI, {
            employeeDataId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("EmployeeData deleted")
        }
        else{
            toast("EmployeeData updated")
        } 
        
        yield put({
            type: EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_SEARCH, search),
    takeFirstSagaUtil(EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_UPSERT, upsert),
    takeFirstSagaUtil(EMPLOYEE_DATA_ACTIONS.EMPLOYEE_DATA_EDIT, edit),
];
